import React, { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import getIcon from "../../utility/getIcon";
import CashlessModal from "./CashlessModal";
import { addItemToCart, removeItemFromCart, emptyWholeCart } from "../../redux/cart/reducer";
import { BackIcon, MinusIcon, PlusIcon, TrashIcon } from "../../components/Icon";
import CareModal from "./CareModal";
import { useTranslation } from "react-i18next";
import { useAlert } from "react-alert";

const CashlessPanier = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const bailProducts = useLocation().state.bailProducts;
  const { orgId } = useParams();

  const [modalOpen, setModalOpen] = useState(false);
  const [careModalOpen, setCareModalOpen] = React.useState(false);
  const cartStore = useSelector((state) => state.cartReducer.cartByOrg[orgId] || []);
  const alert = useAlert();
  const { t } = useTranslation("fastpass");
  let total = 0;

  cartStore?.map((i) => {
    total = parseFloat(i?.totalDue + total);
  });

  const removeItem = (item) => {
    if (!!item.optionCategories?.length) {
      cartStore.map((product) => {
        if (product.parentId && product.parentId === item.id) {
          dispatch(removeItemFromCart({ orgId, item: product }));
        }
      });
    }

    dispatch(removeItemFromCart({ orgId, item }));
  };

  const addItem = (item) => {
    if (!!item.optionCategories?.length || !!item.parentId) {
      alert.show(t("cannotIncreaseProductWithOptions"), { type: "error" });
      return;
    }

    if (item.availableQuantity !== false) {
      const index = cartStore.findIndex((product) => product.id === item.id);
      if (index !== -1 && item.availableQuantity - cartStore[index].quantity <= 0) {
        alert.show(t("maxQuantityReached"), { type: "error" });
        return;
      }
    }

    dispatch(addItemToCart({ orgId, item: item }));
  };

  return (
    <>
      <div className="d-flex flex-column" style={{ minHeight: "100dvh" }}>
        <div className="page-header py-3 position-sticky top-0 zi-50">
          <div className="container">
            <div className="page-title text-start gap-0 py-0">
              <button
                type="button"
                className="back-icon position-relative"
                onClick={() => navigate(`/cashless/${orgId}`)}
                style={{
                  transform: "translate(0)",
                }}
              >
                <BackIcon />
              </button>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{ marginLeft: "8px" }}>{t("cart")}</div>
                <button
                  type="button"
                  className="back-icon position-relative"
                  onClick={() => {
                    dispatch(emptyWholeCart({ orgId }));
                    navigate(-1);
                  }}
                  style={{
                    transform: "translate(0)",
                  }}
                >
                  <TrashIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-4 px-20px">
          {cartStore.map((item, index) => (
            <CartItem
              addToCart={(item) => addItem(item)}
              removeFromCart={(item) => removeItem(item)}
              key={item.id}
              item={item}
              disabledAddButton={item.parentId || item.optionCategories.length}
            />
          ))}
        </div>
        <div className="mt-auto position-sticky bottom-0 zi-50">
          <div className="page-header pt-3 pb-4">
            <div className="container">
              <div className="total--price mt-0 mb-12px">
                <span>{t("total")}</span>
                <span style={{ color: "#27AE60" }}>{total.toFixed(2)}</span>
              </div>
              <button
                type="button"
                className="submitBtn submitBtn2 m-0"
                onClick={() => {
                  if (bailProducts.length > 0) {
                    setModalOpen(true);
                  } else {
                    navigate(`/cashless/${orgId}/payment`);
                  }
                }}
              >
                {t("pay")}
              </button>
            </div>
          </div>
        </div>
      </div>
      <CashlessModal
        open={modalOpen}
        setOpen={setModalOpen}
        total={total}
        bails={bailProducts}
        setCareModalOpen={setCareModalOpen}
      />
      <CareModal open={careModalOpen} setOpen={setCareModalOpen} />
    </>
  );
};

const CartItem = ({ item, addToCart, removeFromCart, disabledAddButton }) => {
  return (
    <>
      <div className="cashless-item cart-item">
        <div className="img">
          <img src={getIcon(item?.category, item?.customIcon)} alt="item" />
        </div>
        <div className="content">
          <p className="subtext">{item.subtitle}</p>
          <h3 className="subtitle">{item.title}</h3>
          <div className="price">
            <span>x{item.quantity}</span>
            <span style={{ color: "#27AE60" }}>{(item.price * item.quantity).toFixed(2)}€</span>
          </div>
        </div>
        <div className="button-group">
          <button type="button" onClick={() => addToCart(item)} disabled={disabledAddButton}>
            <PlusIcon />
          </button>
          <div className="divider"></div>
          <button type="button" onClick={() => removeFromCart(item)}>
            <MinusIcon />
          </button>
        </div>
      </div>
    </>
  );
};

export default CashlessPanier;
